import { useRouterState } from "./useRouterState.js";
function useCanGoBack() {
  return useRouterState({ select: (s) => s.location.state.__TSR_index !== 0 });
}
export {
  useCanGoBack
};
//# sourceMappingURL=useCanGoBack.js.map
